import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IVentaData } from '@core/interfaces/entidades/venta.entidad';
import { IPaginar } from '@core/interfaces/paginacion/paginacion.interface';
import {
  IAnularVentaReq,
  IRealizarVentaReq,
  IReporteVentaDetalleRes,
  IReporteVentaReq,
  IReporteVentaRes,
} from '@core/interfaces/request-response/venta.dto.interface';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class VentaApiService extends BaseHttpService {
  cargarVenta(venta_id: number) {
    return this.withLoader(
      this.httpClient.get<IReporteVentaDetalleRes>(
        `${environment.apiUrl}${environment.apiPreFix}/venta/v2/obtener-venta/${venta_id}`,
      ),
    );
  }
  realizarVenta(req: IRealizarVentaReq) {
    const params = new HttpParams().set('async', environment.asyncServices.toString());
    console.log('Realizando venta con datos:', req);
    return this.withLoader(
      this.httpClient.post<IVentaData>(
        `${environment.apiUrl}${environment.apiPreFix}/venta/v2/generar-venta`,
        req,
        { params },
      ),
    );
  }
  paginarReporte(rq: IReporteVentaReq, pagina: number, size: number) {
    const params = new HttpParams().set('pagina', pagina.toString()).set('size', size.toString());
    return this.withLoader(
      this.httpClient.post<IPaginar<IReporteVentaRes>>(
        `${environment.apiUrl}${environment.apiPreFix}/venta/v2/paginar-reporte`,
        rq,
        { params },
      ),
    );
  }
  exportarReporteExcel(rq: IReporteVentaReq) {
    return this.withLoader(
      this.httpClient.post(
        `${environment.apiUrl}${environment.apiPreFix}/venta/v2/exportar-reporte-excel`,
        rq,
        {
          observe: 'response',
          responseType: 'blob',
        },
      ),
    );
  }
  anularVenta(rq: IAnularVentaReq) {
    const params = new HttpParams().set('async', environment.asyncServices.toString());
    return this.withLoader(
      this.httpClient.post(
        `${environment.apiUrl}${environment.apiPreFix}/venta/v2/anular-venta`,
        rq,
        { params },
      ),
    );
  }
  reemitirVenta(venta_id: number) {
    return this.withLoader(
      this.httpClient.post(
        `${environment.apiUrl}${environment.apiPreFix}/venta/v2/reemitir-venta/${venta_id}`,
        {},
      ),
    );
  }
}
